<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      custom-class="noRadio"
      fullscreen
      :title="titleadd"
      :visible.sync="addNewTaskDiog"
      @close="clearDialog"
    >
      <div class="outSelect" v-if="showSelect">
        <div
          style="
            width: 1px;
            height: 20px;
            background: #e0e0e0;
            margin-left: 24px;
            transform: translateY(6px);
          "
        ></div>
        <div class="rightSelete">
          <div class="leftSelect">
            <div class="innerLeft">
              <el-dropdown
                @command="changeStore"
                @visible-change="oneArrow = !oneArrow"
                trigger="click"
                placement="bottom-start"
              >
                <span class="el-dropdown-link">
                  <span style="margin-right: 3px; color: #000000">{{
                    value1
                  }}</span>
                  <i
                    class="el-icon-arrow-down el-icon--right"
                    v-if="!oneArrow"
                  ></i>
                  <i
                    class="el-icon-arrow-up el-icon--right"
                    v-if="oneArrow"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="changePosition">
                  <el-dropdown-item
                    v-for="item in options1"
                    :key="item.organization_id"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div>
              <el-dropdown
                @command="changeStore2"
                @visible-change="twoArrow = !twoArrow"
                trigger="click"
                placement="bottom-start"
              >
                <span class="el-dropdown-link">
                  <span
                    style="margin-right: 3px; color: #000000"
                    v-if="value2 != ''"
                    >{{ value2 }}</span
                  >
                  <span style="margin-right: 3px; color: #cccccc" v-else
                    >Select</span
                  >
                  <i
                    class="el-icon-arrow-down el-icon--right"
                    v-if="!twoArrow"
                  ></i>
                  <i
                    class="el-icon-arrow-up el-icon--right"
                    v-if="twoArrow"
                  ></i>
                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  class="changePosition"
                  v-if="value2 != ''"
                >
                  <el-dropdown-item
                    v-for="item in options2"
                    :key="item.organization_id"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
                <el-dropdown-menu slot="dropdown" class="changePosition" v-else>
                  <el-dropdown-item disabled>no data</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <add-new-tasks
        v-if="addNewTaskDiog"
        ref="createTasks"
        :title="titleadd"
        @closeDialog="closeNewTaskDialog"
      ></add-new-tasks>
    </el-dialog>
  </div>
</template>

<script>
import addNewTasks from "@/components/addNewTasks";
import EventBus from "@/ws/eventBus";

import { getOrgaList, getSubOrgaList } from "@/api/addressBook";
import store from "@/store/index";

export default {
  name: "addTask",
  props: ["addNewTaskDiog"],
  components: {
    addNewTasks,
  },
  mounted() {},
  created() {
    this.name = JSON.parse(localStorage.getItem("userInfo"))?.type;

    if (this.name == 0 || this.name == 2) {
      this.showSelect = true;
      this.gettopState();
    }
  },
  data() {
    return {
      name: "",
      showSelect: false,
      addNewTaskDiog: false,
      options1: [],
      options2: [],
      value1: "",
      value2: "",
      twoArrow: false,
      titleadd: "Create a New Task",
    };
  },
  computed: {},
  watch: {},
  methods: {
    closeNewTaskDialog() {
      this.addNewTaskDiog = false;
      this.$forceUpdate();
      this.$emit('onCloseTaskDialog')
    },
    clearDialog() {
      this.$refs.createTasks.cancelAdd();
      this.$emit('onCloseTaskDialog')
    },

    //改变第一个值
    changeStore(val) {
      this.value1 = val.name;
      this.organization_id = val.organization_id;
      this.getSubData();
    },
    //改变第二个值
    changeStore2(val) {
      this.value2 = val.name;
      this.$store.commit("changeStore", val.sub_organization_id);
    },
    //获取组织下拉数据
    gettopState() {
      getOrgaList().then((res) => {
        this.options1 = res.data;
        this.value1 = res.data[0].name;
        this.changeValue1 = res.data[0].name;
        this.organization_id = res.data[0].organization_id;
        this.getSubData();
      });
    },
    getSubData() {
      //获取门店下拉数据
      getSubOrgaList({
        organization_id: this.organization_id,
      }).then((res) => {
        this.options2 = res.data;
        if (res.data.length != 0) {
          this.changeValue2 = res.data[0].name;
          this.value2 = res.data[0].name;
          this.$store.commit("changeStore", res.data[0].sub_organization_id);
        } else {
          this.value2 = "";
          this.$store.commit("changeStore", "");
        }
      });
    },

  },
};
</script>

<style scoped lang="less">
.outSelect {
  display: flex;
  position: absolute;
  top: 35px;
  left: 180px;
  .rightSelete {
    display: flex;
  }
  .leftSelect {
    display: flex;
    line-height: 32px;
    margin-left: 24px;
    font-weight: bold;
    div {
      cursor: pointer;
    }
    .innerLeft {
      margin-right: 16px;
    }
  }
}

.tabRightBox {
  position: absolute;
  right: 0;
  top: 0;
  // background-color: #32B0F8;
  // height: 38px;
  height: 55px;
  z-index: 999;
  display: flex;
  flex-direction: row;
  align-items: center;

  .lableBox {
    padding-right: 32px;
    font-weight: bold;
    color: #999999;
    font-size: 14px;
    height: 100%;
    // background-color: #82D237;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .redTexts {
    color: #e95646;
    cursor: pointer;

    // padding-right: 32px;
    margin-right: 32px;
    font-weight: bold;
    font-size: 14px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // border-bottom: 2px solid #E95646;
  }
  .delaytask {
    border-bottom: 2px solid #e95646;
  }
}

// /deep/.el-tabs__nav-wrap{
//   background-color: #1472FF;
//   position: relative;
// }

.changeTop {
  /deep/ .el-dialog__header {
    padding: 32px 32px 24px 32px;
  }
}
.tasksMain {
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #313131;
  }
  .top_tabs {
    width: 322px;
    text-align: center;
    margin-bottom: 24px;
    /deep/.el-tabs__nav {
      background-color: #ececf2 !important;
      border-radius: 16px;
    }
    /deep/.el-tabs__header {
      margin: 0;
    }

    /deep/ .el-tabs__nav-scroll {
      padding-left: 0;
    }
    /deep/ .el-tabs__nav-wrap::after {
      background: none;
    }
    /deep/ .el-tabs__item {
      height: 32px;
      line-height: 32px;
      flex: 1;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    /deep/ .el-tabs__item.is-active {
      background: #e95646;
      color: #ffffff;
      border-radius: 16px;
    }
    /deep/.el-tabs__active-bar {
      background: none;
    }
  }
  .tasksTop {
    padding: 8px;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    /deep/.changeFocus:focus {
      border: 1px solid #dcdfe6;
      color: #606266;
    }
    .topSeach {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 88px;
      }
      /deep/ .el-input__prefix {
        color: #1f2d42;
      }
      .long_search {
        /deep/.el-input__inner {
          padding-left: 115px !important;
        }
      }
      .long_searchs {
        /deep/.el-input__inner {
          padding-left: 133px !important;
        }
      }
      .innerSearch {
        margin: 8px;
        /deep/.el-cascader {
          line-height: 0;
        }
        .innerTime {
          /deep/.el-input__prefix {
            position: absolute;
            top: 0;
            right: 12px;
            left: auto;
          }
          /deep/ .el-input--prefix .el-input__inner {
            padding-left: 12px;
          }
          /deep/.el-input__icon {
            //position: absolute;
            //right: 12px;
            color: #d65953;
          }
        }
        .from {
          /deep/.el-input__inner {
            padding-left: 75px !important;
          }
        }
        .to {
          /deep/.el-input__inner {
            padding-left: 55px !important;
          }
        }
      }
      .cascader {
        position: relative;
        /deep/.el-input__inner {
          padding-left: 80px;
        }
        .slot {
          position: absolute;
          padding-left: 24px;
          font-size: 14px;
          top: 5px;
        }
      }
      .ex {
        width: 300px;
        /deep/ .el-input--prefix .el-input__inner {
          padding-left: 110px;
        }
      }
    }
  }
  .third {
    display: flex;
    padding-right: 5px;
    color: #ffffff;
    height: 18px;
    line-height: 18px;
    margin-top: 8px;
    //background-color: #FFC215;
    font-size: 12px;
    border-radius: 4px;
    .hub {
      background-color: #1f2d42;
      border-radius: 4px;
      padding: 0 5px;
    }
    .pickup {
      background: #cccccc;
      padding: 0 5px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      //margin-right: 5px;
    }
    //.blue{
    //  background:#1472FF;
    //  padding: 0 5px;
    //  border-top-right-radius: 4px;
    //  border-bottom-right-radius: 4px;
    //  //margin-right: 5px;
    //}
    .blues {
      background: #1472ff;
      padding: 0 9px 0 5px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .hubs {
      background-color: #1f2d42;
      border-radius: 4px;
      padding: 0 5px;
      margin-left: -4px;
    }
    .dropoff {
      background: #cdccd1;
      padding: 0 5px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      //margin-right: 5px;
    }
    .yellow {
      padding: 0 5px;
      //margin-right: 5px;
      background: #ffc412;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      margin-left: -2px;
    }
  }
  .tasksTable {
    margin-top: 24px;
    font-weight: normal;
    font-size: 13px;

    .innerTop {
      .outTable {
        margin-top: 17px;
        //height: 58vh;
        //overflow: auto;
        .top {
          height: 32px;
          line-height: 32px;
          background: #ececf2;
          border-radius: 16px 16px 0px 0px;
          border: 1px solid #e0e0e0;
          display: flex;
          justify-content: space-between;
          padding: 0 24px;
          .innerLeft {
            display: flex;
            .middle {
            }
            .middleLine {
              width: 1px;
              height: 16px;
              background-color: #999999;
              margin: 8px 8px 0;
            }
          }
          .titleColor {
            color: #999999;
          }
        }
        .btom {
          //width: 1192px;
          height: 108px;
          background: #ffffff;
          border-radius: 0px 0px 16px 16px;
          border: 1px solid #e0e0e0;
          margin-bottom: 16px;
          display: flex;
          justify-content: flex-end;
          .all {
            padding: 16px 24px;
          }
          .one {
            border-right: 1px solid #e0e0e0;
            display: flex;
            width: 100%;
            .left {
              width: 60px;
              height: 60px;
              background: #1f2d42;
              border-radius: 8px;
              margin-top: 8px;
              img {
                margin-top: 15px;
              }
            }
            .rights {
              margin-left: 16px;
              .innerTop {
                display: flex;
                font-weight: bold;
                color: #1f2d42;
                font-size: 14px;
                line-height: 24px;
                .innerRed {
                  margin-right: 8px;
                  width: 24px;
                  height: 24px;
                  background: #e95646;
                  border-radius: 4px;
                  //vertical-align:middle;
                  img {
                    width: 15px;
                    margin-top: 4px;
                  }
                }
                .pickup_box {
                  width: 24px;
                  height: 24px;
                  border-radius: 50%;
                  margin-left: 15px;
                  img {
                    width: 11px;
                    height: 11px;
                  }
                }
                .delay_no {
                  text-align: center;
                  color: #e95646;
                  width: 59px;
                  height: 24px;
                  border-radius: 12px;
                  border: 1px solid #e95646;
                  padding: 0 5px;
                  margin-left: 16px;
                }
              }
              .innerBtom {
                text-align: left;
                font-size: 13px;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                margin: 8px 0;
                height: 20px;
                overflow: hidden;
              }
            }
          }
          .two {
            width: 192px;
            border-right: 1px solid #e0e0e0;
            font-size: 14px;
            font-weight: 400;
            color: #1f2d42;
            position: relative;
            span {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .three {
            width: 156px;
            border-right: 1px solid #e0e0e0;
            padding-top: 20px;
            .allIn {
              //width: 108px;
              text-align: center;
              margin: 9px auto;
              height: 22px;
              line-height: 22px;
              border-radius: 11px;
              font-size: 13px;
              font-weight: bold;
              color: #ffffff;
            }
          }
          .four {
            width: 100px;
            padding-top: 45px;
            flex-shrink: 0;
            img {
              width: 16px;
              height: 16px;
              margin: 0 8px;
            }
          }
        }
      }
      .btomPagin {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        padding-left: 16px;
        .innerLeft {
          font-size: 16px;
          font-family: SFPro-Regular, SFPro;
          font-weight: 400;
          color: #1f2d42;
          line-height: 20px;
        }
      }
    }
    .empty {
      width: 200px;
      height: 387px;
      margin: 20px auto;
      position: relative;
      img {
        width: 100%;
        height: 200px;
      }
      div {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .footers {
    width: calc(100% - 72px);
    z-index: 2;
    height: 64px;
    background: #1f2d42;
    position: fixed;
    bottom: 0;
    margin-left: -32px;
    line-height: 64px;
    display: flex;
    justify-content: space-between;
    padding-right: 48px;
    padding-left: 32px;
    color: #ffffff;
  }

  .unassigned {
    background-color: #bcbebf;
  }
  .assigned {
    background: #ab81f3;
    border-radius: 16px;
    padding: 0 12px;
    color: #ffffff;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    font-weight: bold;
  }
  .another {
    position: absolute;
    top: 27px;
    left: 140px;
  }
  .completed {
    background-color: #82d237;
  }
  .transit {
    background: #32b0f8;
    border-radius: 16px;
    padding: 0 12px;
    color: #ffffff;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    font-weight: bold;
  }
  .failed {
    background: #e95646;
  }
  .deleted {
    background: #1f2d42;
  }
}
</style>
